import { BenefitDTOBenefitEnum, CustomBenefitDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';

export const useDocumentsQuery = ({
  enabled,
  benefit,
  customBenefit,
}: {
  enabled: boolean;
  benefit: BenefitDTOBenefitEnum;
  customBenefit?: CustomBenefitDTO;
}) =>
  useTenantQuery(
    ['documents', { benefit, customBenefitTemplateKey: customBenefit?.templateKey, page: 0, pageSize: 0 }, apis.documents.listDocuments],
    () => apis.documents.listDocuments({ benefit, page: 0, pageSize: 0 }).then(res => res.data),
    {
      enabled,
    },
  );
